// Module
var code = "<svg width=22 height=22 viewBox=\"0 0 22 22\" fill=none xmlns=http://www.w3.org/2000/svg> <path d=\"M1 1L21 21\" stroke=black /> <path d=\"M21 1L1 21\" stroke=black /> </svg> ";
// Exports
module.exports = code;